import Lottie, { LottieRefCurrentProps } from "lottie-react";
import { JSX } from "preact";

import usernameAnim from "../controllers/modals/components/legacy/usernameUpdateLottie.json";

type Element =
    | string
    | {
          type: "image";
          src: string;
          shadow?: boolean;
      }
    | { type: "element"; element: JSX.Element };

export interface ChangelogPost {
    date: Date;
    title: string;
    content: Element[];
}

export const changelogEntries: Record<number, ChangelogPost> = {
    1: {
        date: new Date("2025-06-09T20:00:00.000Z"),
        title: "Известные баги",
        content: [
            "Счетчик непрочитанных часто показывает невалидную информацию",
            "Переключение ролей без сохранения изменений: https://redmine.opencode.su/issues/77638",
            "Одинаковые смайлики: https://redmine.opencode.su/issues/77498",
            "Исправление текста уведомлений при выходе из беседы: https://redmine.opencode.su/issues/76101",
            "Отображать имена тегнутых участников в групповых чатах (вне серверов): https://redmine.opencode.su/issues/72415",
            "При копировании юзермейма в окне пользователя отсутствует тултип об успешном копировании: https://redmine.opencode.su/issues/76102",
            "В поле ввода не отображается форматирование и смайлики: https://redmine.opencode.su/issues/76051",
            "Не запоминается выбранный стиль эмодзи после рестарта приложения: https://redmine.opencode.su/issues/75735",
            "Некорректная верстка окна смайликов: https://redmine.opencode.su/issues/69667",
        ],
    },
    2: {
        date: new Date("2025-06-09T20:00:00.000Z"),
        title: "Дорожная карта",
        content: [
            "Календарь мероприятий проекта",
            "Информирование о прочитанности сообщений",
            "Избранные реакции",
            "Возможность задавать права доступа группе каналов",
            "Просмотр сервера от лица роли или от нескольких ролей одновременно",
            "Переход к непрочитанному сообщению при клике на сервер",
            "Алфавитная сортировка пользователей в списке участников",
            "Предложения и баги можно заводить в https://redmine.opencode.su/projects/revolt/issues",
        ],
    },
    4: {
        date: new Date("2025-06-09T20:00:00.000Z"),
        title: "Ноябрь 2025",
        content: [
            "*Добавлены звонки в голосовых каналах*",
            "Добавлены часто используемые реакции",
            "Исправлен баг с уменьшенным размером окна при разворачивании из панели задач",
        ],
    },
    5: {
        date: new Date("2025-06-09T20:00:00.000Z"),
        title: "Октябрь 2025",
        content: [
            "Добавлена возможность написать в техподдержку (Настройки -> Обратная связь)",
            "Разрешено закреплять не только свои сообщения",
            "Добавлена строка поиска при добавлении контактов на сервер",
            "Исправлено редактирование больших сообщений",
            "Синхронизация имени пользователя в Revolt и в LDAP",
            "Поиск и автоматическая регистрация всех пользователей из LDAP на сервере",
            "Удаленные аккаунты пропадают из списка контактов, старые чаты и сообщения сохраняются",
            "Устранены известные уязвимости веб сервера",
        ],
    },
    6: {
        date: new Date("2025-06-09T20:00:00.000Z"),
        title: "Сентябрь 2025",
        content: [
            "Открытие текстовых файлов по клику",
            "Добавлена возможность прямого добавления участников на сервер без приглашения",
            "Исправлен баг с переходом в список диалогов в первый раз с мобильного устройства",
            "Исправления багов со скачиванием файлов",
            "Создание серверов по шаблону",
            "Обработка ошибки блокировки входа через LDAP",
        ],
    },
    7: {
        date: new Date("2025-06-09T20:00:00.000Z"),
        title: "Август 2025",
        content: [
            "Переход между несколькими изображениями, если у сообщения несколько вложений",
            "Сохранение файлов в Desktop клиенте в Downloads/Revolt в папке пользователя",
            "Локализованы все элементы интерфейса",
            "Отображение заглушенных контактов в списке бесед",
        ],
    },
    8: {
        date: new Date("2025-06-09T20:00:00.000Z"),
        title: "Июль 2025",
        content: [
            "Автоматическое копирование ссылки-приглашения на сервер после ее создания",
            "Автоскролл при отправке сообщения",
            "Добавлены элементы форматирования текста",
            "Запрещено изменять имя пользователя",
            "Улучшен внешний вид окна поиска по чату",
        ],
    },
    9: {
        date: new Date("2025-06-09T20:00:00.000Z"),
        title: "Июнь 2025",
        content: [
            "Добавлена возможность наделить роль правами администратора",
            "Убрана кнопка звонков до интеграции с Око",
            "Скрыт статус 'Невидимый' для всех пользователей",
            "Скрыты пункты меню 'Пожаловаться' для серверов, пользователей и сообщений",
            "Подготовка к интеграции с корпоративным LDAP",
            "Убрано дублирование в панели задач",
            "Исправлено мигание значка в панели задач",
        ],
    },
    10: {
        date: new Date("2025-05-01T20:00:00.000Z"),
        title: "Май 2025",
        content: [
            "Разрешена отправка всем пользователям, а не только друзьям",
            "Реализован переход в чат, связанный с уведомлением при клике на уведомление",
            "Забраны изменения из основного репозитория revolt: массовые теги и другие исправления",
            "Добавлены права всем существующим пользователям для массовых тегах",
            "Добавлено версионирование фронтенда дополнительно к SHA коммита",
            "Исправлены спонтанные реконнекты клиента",
        ],
    },
    11: {
        date: new Date("2025-04-01T20:00:00.000Z"),
        title: "Апрель 2025",
        content: [
            "Реализовано переподключение при разрыве связи со стороны сервера",
            "Улучшение превью-ссылок, когда в метаданных нет ничего, кроме заголовка",
            "Уменьшен размер превью-ссылок",
            "Добавлена возможность прикрепления сообщений",
            "В панель задач добавлен счетчик непрочитанных уведомлений",
            "Добавлен счетчик непрочитанных возле чата",
            "Улучшено автодополнение по ролям и пользователям - регистронезависимый поиск",
            "Desktop приложение теперь всегда самой актуальной версии на сервере",
            "Исправлено копирование ссылки-приглашения на сервер",
        ],
    },
    12: {
        date: new Date("2025-03-17T20:00:00.000Z"),
        title: "Март 2025",
        content: [
            "Увеличен лимит загружаемых вложений до 256 Мб",
            "В десктопную версию добавлено автообновление electron приложения",
            "Добавлена возможность тегирования по ролям и @everyone",
            "Причесан интерфейс в настройках: убраны лишние кнопки, заменены ссылки на наши репозитории (исходные коды, SHA коммитов) и наш redmine (обратная связь)",
            "Добавлен наш список изменений по спринтам",
            "Реализовано отображение имени пользователя вместо его идентификатора в поле ввода при теггировании",
            "Увеличено количество элементов в списке выбора при теггировании с 5 до 25",
            "При наведении на реакции появляется список пользователей, поставивших реакцию",
            "Добавлен редактор ролей в профиль пользователя (при наличии прав)",
            "В контекстное меню пользователей справа и в чате добавлена возможность быстрого открытия редактора ролей",
            "Исправлен баг с выравниванием размера файлов нулями в конце при сохранении вложений",
        ],
    },
    13: {
        date: new Date("2025-03-01T20:00:00.000Z"),
        title: "Февраль 2025",
        content: [
            "Добавлен установочный файл desktop приложения: https://revolt.opencode.su/revolt.exe",
            "Открытие главного окна при двойном клике в трее",
            "Возможность тегать пользователя по любому из его имен: username, имя на сервере, имя в профиле вне сервера",
            "Смайлики прогружаются с наших серверов, убрана зависимость от внешнего CDN",
            "Увеличен лимит отправки сообщений с 2000 символов до 90 000",
            "В каналах в списке пользователей теперь отображаются только актуальные пользователи (с правами на чтение)",
            "Исправления мелких ошибок и недочетов, настройка разворачивания и другие мелочи",
        ],
    },
};

export const changelogEntryArray = Object.keys(changelogEntries).map(
    (index) => changelogEntries[index as unknown as number],
);

export const latestChangelog = changelogEntryArray.length;
